/**
 * Created by zhaoyao on 2021/6/8
 * Desc: 电子学生证
 */

import React, { Component } from 'react'
import {Card, WingBlank, List, Toast, Tabs, WhiteSpace} from "antd-mobile";
import { fetchGet, fetchPost, fetchPostObj } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import { getSearchParams, isObjEmpty } from '../../utils/common'
import { switchUser } from '../../redux/actions/userInfo'
import { Icon, message, Button, Cascader, Avatar } from 'antd'
import {getIntValue, getStrValue, isObjNull } from '../../utils/common'
import './ElectronicApply.css';
import {connect} from 'react-redux'

class ElectronicCardOff extends Component {

    componentWillMount() {
        document.title = "远程重启";
    }

    constructor (props) {
        super(props)

        this.state = {
           IMEI: this.props.match.params.IMEI,
        }
    }

    componentDidMount () {
        //Toast.loading('努力加载中...', 0)
        //this.getSchoolList()
        //this.onChange()
    }

    render() {
        const {IMEI } = this.state;

        return (
            <div>
                提示：远程重启时，请保持设备处于开机联网状态。
                <Button type="primary" block className='commonButton' style={{marginTop: '35px',borderRadius: '30px',}}
                                        onClick={this.butShutdown}>远程重启</Button>
            </div>
        )
    }

    butShutdown = (value) => {

      fetchPost(API.UPDATE_ELECTRONIC_SHUTDOWN, {
            IMEI: this.state.IMEI,
            parameter: 2
        }).then(response => {
            if (response.success) {
                this.isRequesting = true
                Toast.show(response.data, 1)

                this.backTask = setTimeout(() => {
                    this.props.history.goBack();
                }, 1000)
            }

        }).catch(error => {
            Toast.hide();

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
      })
  }

}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ElectronicCardOff)
